
  import { defineComponent, onUnmounted } from 'vue';
  import { Container } from '@/ui/components/Container';
  import { Box } from '@/ui/components/Box';
  import { ForbiddenPage } from '@/ui/pages/error/ForbiddenPage';
  import { Loader } from '@/ui/components/Loader';
  import { PageTitle } from '@/ui/components/PageTitle';
  import ScheduleForm from '@/ui/components/schedule/ScheduleForm.vue';
  import { useSchedule } from '@/ui/concerns/schedule/useSchedule';
  import { useCurrentRoute } from '@/ui/routes';
  import { useTimeZonedDates } from '@/ui/concerns/useTimeZonedDates';

  export default defineComponent({
    name: 'ScheduleCreatePage',
    components: {
      ScheduleForm,
      PageTitle,
      Container,
      Box,
      Loader,
      ForbiddenPage,
    },
    setup() {
      const currentRoute = useCurrentRoute();
      const fromId = currentRoute.value.query.fromId ?? '';

      const propsFn = () => ({
        resourceId: fromId.toString(),
        isCloning: !!fromId,
      });

      const {
        canAccessPage,
        store,
        entityItemOptions,
        checklistOptions,
        assigneeOptions,
        getOptions,
        getRecord,
        createRecord,
        updateUserOptions,
      } = useSchedule(parseInt(propsFn().resourceId, 10));

      const { getDateInLocalTimeZone } = useTimeZonedDates();

      if (!propsFn().isCloning) {
        store.updateRuleStart(getDateInLocalTimeZone(store.record.rule.start!));
      }

      const getData = propsFn().isCloning ? getRecord : getOptions;

      onUnmounted(() => store.$reset());

      return {
        canAccessPage,
        getData,
        createRecord,
        entityOptions: entityItemOptions,
        checklistOptions,
        userOptions: assigneeOptions,
        updateUserOptions,
      };
    },
  });
